import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import './LegalShell.css';

interface Props {
  readonly title: string;
  readonly version: string;
  readonly effective: string;
  readonly children: ReactNode;
}

export default function LegalShell({ title, version, effective, children }: Props) {
  return (
    <article className="om-legal">
      <Link to="/" className="om-legal__home">← OculusMind.AI</Link>
      <header className="om-legal__header">
        <h1>{title}</h1>
        <p className="om-legal__meta">
          Version <code>{version}</code> &middot; Effective {effective}
        </p>
      </header>
      <div className="om-legal__body">{children}</div>
    </article>
  );
}
